import React, { useState, useEffect, useMemo, useCallback } from "react"
import { Table, Col, Row, Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap"
import api from "API/Api"
import { Link } from "react-router-dom"
import SweetAlert from "react-bootstrap-sweetalert"
import loader from "./../../assets/loading/loader.gif"
import BulkImportExport from "../../components/BulkImportExport"
import { usePermissions } from "API/PermissionContext"

const Staffs = () => {
  const { canAdd, canEdit, canDelete, canExport, MODULE } = usePermissions()
  const MID = MODULE.STAFFS
  const [staffs, setStaffs] = useState([])
  const [dataLoaded, setDataLoaded] = useState(false)
  const [checkedItems, setCheckedItems] = useState({})
  const [parentChecked, setParentChecked] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_multiple_alert, setconfirm_multiple_alert] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [staffId, setStaffId] = useState("")
  const [search, setSearch] = useState("")
  const [showFilter, setShowFilter] = useState(false)
  const [filterDesig, setFilterDesig] = useState("")
  // Designation modal
  const [desigModal, setDesigModal] = useState(false)
  const [designations, setDesignations] = useState([])
  const [desigName, setDesigName] = useState("")
  const [desigLoading, setDesigLoading] = useState(false)
  const [desigDeleting, setDesigDeleting] = useState(null)

  const fetchData = useCallback(async () => {
    try {
      const resp = await api.get("staffs")
      setStaffs(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
    setDataLoaded(true)
  }, [])

  const fetchDesignations = useCallback(async () => {
    try {
      const resp = await api.get("designations")
      setDesignations(Array.isArray(resp.data.data) ? resp.data.data : resp.data.data?.data || [])
    } catch (e) { console.error(e) }
  }, [])

  useEffect(() => { fetchData(); fetchDesignations() }, [fetchData, fetchDesignations])

  const handleDelete = async () => {
    try { await api.delete("delete-staff/" + staffId); fetchData() } catch (e) { console.error(e) }
  }
  const handleMultiDelete = async () => {
    const ids = Object.keys(checkedItems).filter(k => checkedItems[k])
    if (!ids.length) return
    try {
      await Promise.all(ids.map(id => api.delete("delete-staff/" + id)))
      setCheckedItems({}); setParentChecked(false); fetchData()
    } catch (e) { console.error(e) }
  }
  const handleCheckbox = id => {
    setCheckedItems(prev => {
      const n = { ...prev, [id]: !prev[id] }
      setParentChecked(staffs.length > 0 && staffs.every(p => n[p.id]))
      return n
    })
  }
  const handleParentCheckbox = () => {
    const n = !parentChecked; setParentChecked(n)
    const items = {}; staffs.forEach(p => { items[p.id] = n }); setCheckedItems(items)
  }
  const selectedCount = Object.values(checkedItems).filter(Boolean).length

  // Designation CRUD
  const addDesignation = async () => {
    if (!desigName.trim()) return
    setDesigLoading(true)
    try {
      await api.post("create-designation", { designation: desigName.trim() })
      setDesigName("")
      fetchDesignations()
    } catch (e) { console.error(e) }
    setDesigLoading(false)
  }
  const deleteDesignation = async (id) => {
    setDesigDeleting(id)
    try {
      await api.delete("delete-designation/" + id)
      fetchDesignations()
    } catch (e) { console.error(e) }
    setDesigDeleting(null)
  }

  // Unique designations for filter
  const uniqueDesigs = useMemo(() => [...new Set(staffs.map(s => s.designationName || s.designation).filter(Boolean))].sort(), [staffs])

  const filtered = useMemo(() => {
    return staffs.filter(p => {
      const desigDisplay = p.designationName || p.designation || ""
      if (filterDesig && desigDisplay !== filterDesig) return false
      if (search) {
        const s = search.toLowerCase()
        return (p.staffName || "").toLowerCase().includes(s) ||
          (p.staffMobile || "").toLowerCase().includes(s) ||
          (desigDisplay).toLowerCase().includes(s) ||
          (p.staffEmail || "").toLowerCase().includes(s)
      }
      return true
    })
  }, [staffs, search, filterDesig])

  const actionBtnStyle = (bg) => ({
    width: "28px", height: "28px", borderRadius: "4px", background: bg, color: "#fff",
    border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "12px", cursor: "pointer"
  })

  const summaryCards = [
    { label: "Total Staff", value: staffs.length, icon: "fa-user-tie", color: "#6366f1" },
    { label: "Designations", value: new Set(staffs.map(s => s.designationName || s.designation).filter(Boolean)).size, icon: "fa-id-badge", color: "#22c55e" },
  ]

  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "8px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <h4 style={{ margin: 0 }}>Staffs</h4>
            {canAdd(MID) && (
              <Link to="/add-staff" title="Add Staff"
                style={{ ...actionBtnStyle("#28a745"), textDecoration: "none", width: "32px", height: "32px", fontSize: "14px" }}>
                <i className="fas fa-plus"></i>
              </Link>
            )}
            {canDelete(MID) && (
              <button title={selectedCount > 0 ? `Delete ${selectedCount} selected` : "Select items to delete"}
                onClick={() => { if (selectedCount > 0) setconfirm_multiple_alert(true); else alert("Please select at least one staff to delete.") }}
                style={{ ...actionBtnStyle("#dc3545"), width: "32px", height: "32px", fontSize: "14px", opacity: selectedCount > 0 ? 1 : 0.7 }}>
                <i className="fas fa-trash"></i>
              </button>
            )}
            <button title="Toggle Filter" onClick={() => setShowFilter(!showFilter)}
              style={{ ...actionBtnStyle("#0d6efd"), width: "32px", height: "32px", fontSize: "14px" }}>
              <i className="fas fa-filter"></i>
            </button>
            <button title="Manage Designations" onClick={() => setDesigModal(true)}
              style={{ ...actionBtnStyle("#f59e0b"), width: "32px", height: "32px", fontSize: "14px" }}>
              <i className="fas fa-id-badge"></i>
            </button>
            <BulkImportExport
              data={staffs}
              columns={[
                { key: "staffName", label: "Staff Name", required: true },
                { key: "staffMobile", label: "Staff Mobile", required: true },
                { key: "designation", label: "Designation ID", required: true },
                { key: "staffEmail", label: "Email" },
                { key: "staffAddress", label: "Address" },
                { key: "salary", label: "Salary" },
                { key: "joiningDate", label: "Joining Date" },
              ]}
              sampleData={[{ staffName: "John Doe", staffMobile: "9876543210", designation: "1", staffEmail: "john@example.com", salary: "25000", joiningDate: "2024-01-01" }]}
              apiEndpoint="create-staff"
              entityName="Staffs"
              onImportComplete={fetchData}
              showExport={canExport(MID)}
              showImport={canAdd(MID)}
            />
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Search"
              style={{ width: "180px", borderRadius: "4px 0 0 4px" }}
              value={search} onChange={e => setSearch(e.target.value)} />
            <button className="btn btn-primary btn-sm" style={{ borderRadius: "0 4px 4px 0", height: "31px" }}>
              <i className="fas fa-search"></i>
            </button>
          </div>
        </div>

        {/* Summary Cards */}
        <Row className="mb-3 mt-2">
          {summaryCards.map((card, i) => (
            <Col md={3} sm={6} key={i}>
              <div style={{
                background: "#fff", borderRadius: "10px", padding: "14px 16px",
                borderLeft: `4px solid ${card.color}`, boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px"
              }}>
                <div style={{ width: "40px", height: "40px", borderRadius: "8px", background: card.color + "15",
                  display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <i className={`fas ${card.icon}`} style={{ color: card.color, fontSize: "16px" }}></i>
                </div>
                <div>
                  <div style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b" }}>{card.value}</div>
                  <div style={{ fontSize: "11px", color: "#6c757d", textTransform: "uppercase", letterSpacing: "0.5px" }}>{card.label}</div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <div className="table-responsive">
          <Table className="table mb-0 dairyTbl">
            <thead>
              <tr>
                <th><input type="checkbox" checked={parentChecked} onChange={handleParentCheckbox} /></th>
                <th>#</th>
                <th>Staff Name</th>
                <th>Mobile</th>
                <th>Designation</th>
                <th>Email</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {showFilter && (
                <tr>
                  <td></td><td></td>
                  <td><input type="text" className="form-control form-control-sm" placeholder="Name..." value={search} onChange={e => setSearch(e.target.value)} /></td>
                  <td></td>
                  <td>
                    <select className="form-control form-control-sm" value={filterDesig} onChange={e => setFilterDesig(e.target.value)}>
                      <option value="">All</option>
                      {uniqueDesigs.map((d, i) => <option key={i} value={d}>{d}</option>)}
                    </select>
                  </td>
                  <td></td><td></td>
                </tr>
              )}
              {dataLoaded ? (
                filtered.length > 0 ? filtered.map((data, i) => (
                  <tr key={data.id}>
                    <td><input type="checkbox" checked={!!checkedItems[data.id]} onChange={() => handleCheckbox(data.id)} /></td>
                    <td>{i + 1}</td>
                    <td style={{ fontWeight: 600 }}>{data.staffName}</td>
                    <td>{data.staffMobile || "—"}</td>
                    <td>
                      <span style={{ background: '#22c55e15', color: '#22c55e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>
                        {data.designationName || data.designation || "—"}
                      </span>
                    </td>
                    <td>{data.staffEmail || "—"}</td>
                    <td>
                      <div style={{ display: "flex", gap: "3px" }}>
                        {canEdit(MID) && <Link title="Edit" to={"/edit-staff/" + data.id} style={actionBtnStyle("#0d6efd")}>
                          <i className="fas fa-edit"></i></Link>}
                        {canDelete(MID) && (
                          <button title="Delete" onClick={() => { setStaffId(data.id); setconfirm_alert(true) }} style={actionBtnStyle("#dc3545")}>
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={7} className="text-center py-4">
                    <i className="fas fa-user-tie fa-2x text-muted mb-2 d-block"></i>No staff found
                  </td></tr>
                )
              ) : (
                <tr><td colSpan={7}><img className="loaderImg" src={loader} alt="loading" /></td></tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>

      {/* ── Designation Management Modal ── */}
      <Modal isOpen={desigModal} toggle={() => setDesigModal(false)} size="md">
        <ModalHeader toggle={() => setDesigModal(false)}>
          <i className="fas fa-id-badge me-2" style={{ color: "#f59e0b" }}></i>Manage Designations
        </ModalHeader>
        <ModalBody>
          {/* Add new */}
          <div style={{ display: "flex", gap: "8px", marginBottom: "16px" }}>
            <input type="text" className="form-control form-control-sm" placeholder="Designation Name *"
              value={desigName} onChange={e => setDesigName(e.target.value)}
              onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); addDesignation() } }}
              style={{ flex: 1 }} />
            <button className="btn btn-success btn-sm" onClick={addDesignation} disabled={desigLoading || !desigName.trim()}
              style={{ minWidth: "70px" }}>
              {desigLoading ? <Spinner size="sm" /> : <><i className="fas fa-plus me-1"></i>Add</>}
            </button>
          </div>
          {/* List */}
          {designations.length > 0 ? (
            <div style={{ maxHeight: "350px", overflowY: "auto" }}>
              <Table className="table table-bordered table-sm mb-0" style={{ fontSize: "13px" }}>
                <thead style={{ background: "#f8fafc", position: "sticky", top: 0 }}>
                  <tr>
                    <th style={{ width: "40px" }}>#</th>
                    <th>Designation Name</th>
                    <th style={{ width: "70px" }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {designations.map((d, i) => (
                    <tr key={d.id}>
                      <td>{i + 1}</td>
                      <td style={{ fontWeight: 600 }}>{d.designation}</td>
                      <td>
                        <button title="Delete" onClick={() => deleteDesignation(d.id)}
                          disabled={desigDeleting === d.id}
                          style={{
                            width: "26px", height: "26px", borderRadius: "4px", background: "#dc3545", color: "#fff",
                            border: "none", display: "inline-flex", alignItems: "center", justifyContent: "center",
                            fontSize: "11px", cursor: "pointer", opacity: desigDeleting === d.id ? 0.5 : 1
                          }}>
                          {desigDeleting === d.id ? <Spinner size="sm" style={{ width: "12px", height: "12px" }} /> : <i className="fas fa-trash-alt"></i>}
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          ) : (
            <p className="text-muted text-center py-3 mb-0">
              <i className="fas fa-id-badge fa-2x d-block mb-2" style={{ opacity: 0.3 }}></i>
              No designations yet. Add one above.
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <span style={{ fontSize: "12px", color: "#6c757d", flex: 1 }}>{designations.length} designation(s)</span>
          <Button color="secondary" size="sm" onClick={() => setDesigModal(false)}>Close</Button>
        </ModalFooter>
      </Modal>

      {confirm_alert && (
        <SweetAlert title="Are you sure?" warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleDelete(); setconfirm_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Staff deleted.") }}
          onCancel={() => setconfirm_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {confirm_multiple_alert && (
        <SweetAlert title={`Delete ${selectedCount} staff?`} warning showCancel confirmBtnBsStyle="success" cancelBtnBsStyle="danger"
          onConfirm={() => { handleMultiDelete(); setconfirm_multiple_alert(false); setsuccess_dlg(true); setdynamic_title("Deleted"); setdynamic_description("Staff deleted.") }}
          onCancel={() => setconfirm_multiple_alert(false)}>You won't be able to revert this!</SweetAlert>
      )}
      {success_dlg && (
        <SweetAlert success title={dynamic_title} onConfirm={() => setsuccess_dlg(false)}>{dynamic_description}</SweetAlert>
      )}
    </>
  )
}

export default Staffs
